import {
  EVENT_TYPE_OPTIONS,
  WHATSAPP_DEFAULT_GREETING,
  WHATSAPP_NUMBER,
} from "../constants/siteContact";

/**
 * @param {object} data
 * @param {string} [data.eventType]
 * @param {string} [data.eventDate]
 * @param {string} [data.guestCount]
 * @param {string} [data.name]
 * @param {string} [data.phone]
 * @param {string} [data.details]
 */
export function formatInquiryMessage(data = {}) {
  const lines = [
    "Hi Panthi Events, I would like to inquire about an event.",
    "",
  ];

  if (data.eventType) {
    const label =
      EVENT_TYPE_OPTIONS.find((o) => o.value === data.eventType)?.label ||
      data.eventType;
    lines.push(`Event type: ${label}`);
  }
  if (data.eventDate?.trim()) {
    lines.push(`Date: ${data.eventDate.trim()}`);
  }
  if (data.guestCount?.trim()) {
    lines.push(`Guests: ${data.guestCount.trim()}`);
  }
  if (data.name?.trim()) {
    lines.push(`Name: ${data.name.trim()}`);
  }
  if (data.phone?.trim()) {
    lines.push(`Phone: ${data.phone.trim()}`);
  }
  if (data.details?.trim()) {
    lines.push(`Details: ${data.details.trim()}`);
  }

  return lines.join("\n");
}

export function buildWhatsAppUrl(text) {
  const message = text?.trim() || WHATSAPP_DEFAULT_GREETING;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export function buildInquiryWhatsAppUrl(data) {
  return buildWhatsAppUrl(formatInquiryMessage(data));
}

export function buildDefaultWhatsAppUrl() {
  return buildWhatsAppUrl(WHATSAPP_DEFAULT_GREETING);
}
